<template>
    <auth>
        <b-form
            @submit.stop.prevent="onSubmit"
            @reset.stop.prevent="onReset"
            v-if="show"
            class="col-md-6 offset-md-3 text-center"
        >
            <b-form-group label="Editar senha:">
                
                <b-form-input
                    v-model="form.password"
                    type="password"
                    required
                    placeholder="Digite a nova senha"
                ></b-form-input>
            </b-form-group>

            <b-form-group label="Confirmar senha:">

                <b-form-input
                    v-model="form.password_confirmation"
                    type="password"
                    required
                    placeholder="Confirme a nova senha"
                ></b-form-input>

            </b-form-group>

            <b-button type="submit" variant="primary">Salvar nova senha</b-button>
            &nbsp;&nbsp;&nbsp;
            <b-button type="reset" variant="danger">Limpar</b-button>
            &nbsp;&nbsp;&nbsp;
            <b-button type="button" variant="warning" @click="goback">Voltar</b-button>
        </b-form>
    </auth>
</template>

<script>
import Auth from "./../layouts/Auth";
import Swal from "sweetalert2";
import { recoverAction, resetAction, confirmResetAction } from "./../configs/services";
import Bus from "./../configs/bus";

export default {
    name: "Signup",
    components: {
        Auth
    },
    data() {
        return {
            form: {
                password: "",
                password_confirmation: ""
            },
            show: true
        };
    },
    created(){
        const vm = this;

        Bus.$emit("toggle", null);

        confirmResetAction(this.$route.params.token)
        .then(item => {
            console.log(item);
        })
        .catch(err => {
            Swal.fire("Error", "Token inválido", "danger").then(() => {
                vm.$router.push({name: "Login"})
            });
        })
        .then(function() {
            Bus.$emit("toggle", null);
        });
    },
    methods: {
        
        goback(){
            window.history.back();
        },
        onSubmit(evt) {
            console.log(JSON.stringify(this.form));

            Bus.$emit("toggle", null);
            
            resetAction(this.form, this.$route.params.token)
            .then(item => {
                console.log(item);
                Swal.fire("Sucesso!", "Senha modificada com sucesso", "success");
            })
            .catch(this.errorHandler)
            .then(function() {
                Bus.$emit("toggle", null);
            });
        },
        onReset(evt) {
            // Reset our form values
            this.form = {
                password: "",
                password_confirmation: ""
            };
            // Trick to reset/clear native browser form validation state
            this.show = false;
            this.$nextTick(() => {
                this.show = true;
            });
        }
    }
};
</script>
